import React from 'react';
import styled from 'styled-components';
import indents from '../../../../../constants/js/indents.js';
const constantPadding = {
  h56: indents.indentS,
  h48: indents.indent12
};
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-1ucuk3i-0"
})(["padding:", ";"], ({
  size
}) => `${constantPadding[size]} ${constantPadding[size]} 0 ${constantPadding[size]}`);
export const TextContainer = ({
  children,
  size
}) => {
  return React.createElement(StyledContainer, {
    size: size
  }, children);
};